export default __webpack_public_path__ + "static/media/5.32c2a7a8.svg";